import createIcon from '../../createIcon';

/**
 * @component @name WorkspacePremium
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS42OCAxMy4xOUwxMiAxMS40M0wxNC4zMSAxMy4xOUwxMy40MyAxMC4zNEwxNS43NSA4LjVIMTIuOTFMMTIgNS42OUwxMS4wOSA4LjVIOC4yNUwxMC41NiAxMC4zNEw5LjY4IDEzLjE5Wk0yMCA5LjVDMjAgNS4wOCAxNi40MiAxLjUgMTIgMS41QzcuNTggMS41IDQgNS4wOCA0IDkuNUM0IDExLjUzIDQuNzYgMTMuMzcgNiAxNC43OFYyMi41TDEyIDIwLjVMMTggMjIuNVYxNC43OEMxOS4yNCAxMy4zNyAyMCAxMS41MyAyMCA5LjVaTTEyIDMuNUMxNS4zMSAzLjUgMTggNi4xOSAxOCA5LjVDMTggMTIuODEgMTUuMzEgMTUuNSAxMiAxNS41QzguNjkgMTUuNSA2IDEyLjgxIDYgOS41QzYgNi4xOSA4LjY5IDMuNSAxMiAzLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WorkspacePremium = createIcon('WorkspacePremium', [
  [
    'path',
    {
      d: 'M9.68 13.19L12 11.43L14.31 13.19L13.43 10.34L15.75 8.5H12.91L12 5.69L11.09 8.5H8.25L10.56 10.34L9.68 13.19ZM20 9.5C20 5.08 16.42 1.5 12 1.5C7.58 1.5 4 5.08 4 9.5C4 11.53 4.76 13.37 6 14.78V22.5L12 20.5L18 22.5V14.78C19.24 13.37 20 11.53 20 9.5ZM12 3.5C15.31 3.5 18 6.19 18 9.5C18 12.81 15.31 15.5 12 15.5C8.69 15.5 6 12.81 6 9.5C6 6.19 8.69 3.5 12 3.5Z',
      key: 'kkv4yu',
    },
  ],
]);

export default WorkspacePremium;
